import { MapPin, UtensilsCrossed } from "lucide-react";
import { LINKS } from "../data/content";
import { CONVERSIONS, reportConversion } from "../utils/gtag";

export default function StickyCTA() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-neon/15 bg-espresso/90 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl md:hidden"
      data-testid="mobile-sticky-cta"
    >
      <div className="flex gap-3">
        <a
          href={LINKS.maps}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-directions-btn"
          onClick={() => reportConversion(CONVERSIONS.directions)}
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-neon py-3 text-sm font-medium text-espresso shadow-[0_0_30px_rgba(255,184,0,0.35)] active:scale-95"
        >
          <MapPin size={15} />
          Get Directions
        </a>
        <a
          href={LINKS.zomatoOrder}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-zomato-btn"
          onClick={() => reportConversion(CONVERSIONS.zomatoOrder)}
          className="flex flex-1 items-center justify-center gap-2 rounded-full border border-cream/25 py-3 text-sm font-medium text-cream active:scale-95"
        >
          <UtensilsCrossed size={15} />
          Order on Zomato
        </a>
      </div>
    </div>
  );
}
